import { render, staticRenderFns } from "./addactivityinfo.vue?vue&type=template&id=0ebda8cc&scoped=true"
import script from "./addactivityinfo.vue?vue&type=script&lang=js"
export * from "./addactivityinfo.vue?vue&type=script&lang=js"
import style0 from "./addactivityinfo.vue?vue&type=style&index=0&id=0ebda8cc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebda8cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ebda8cc')) {
      api.createRecord('0ebda8cc', component.options)
    } else {
      api.reload('0ebda8cc', component.options)
    }
    module.hot.accept("./addactivityinfo.vue?vue&type=template&id=0ebda8cc&scoped=true", function () {
      api.rerender('0ebda8cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/addactivity/addactivityinfo.vue"
export default component.exports